import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
    itemGrid: {
        width: '100vw',
    },
    closeIcon: {
        color: '#b6b6b6',
    },
    mobileCloseIcon: {
        color: '#b6b6b6',
        fontSize: '1rem',
    },
    itemContent: {
    },
    media: {
        height: '27vh',
    },
    mobileMedia: {
        height: '23vw',
    },
    picture: {
        boxShadow: 'none',
    },
    divider: {
        width: '100%',
        marginTop: 15,
        marginBottom: 15,
    },
    name: {
        fontSize: '1.3rem',
    },
    mobileName: {
        fontSize: '0.85rem',
    },
    price: {
        fontSize: '1.1rem',
    }, 
    mobilePrice: {
        fontSize: '0.8rem',
    },
}));

